import { render, staticRenderFns } from "./PageDocument.vue?vue&type=template&id=7487f729&"
import script from "./PageDocument.vue?vue&type=script&lang=js&"
export * from "./PageDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports